require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\gatsby\\\\dist\\\\utils\\\\babel-plugin-extract-graphql.js\",\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\babel-plugin-add-module-exports\\\\lib\\\\index.js\",\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\babel-plugin-transform-object-assign\\\\lib\\\\index.js\"],\"presets\":[[\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\babel-preset-env\\\\lib\\\\index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\babel-preset-stage-0\\\\lib\\\\index.js\",\"C:\\\\Users\\\\markl\\\\Projects\\\\simple-gatsby-site\\\\node_modules\\\\babel-preset-react\\\\lib\\\\index.js\"],\"cacheDirectory\":true}!./404.jsx") })
        }
      }, "component---src-pages-404-jsx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-404-jsx!./src/pages/404.jsx
// module id = 502
// module chunks = 231608221292675